import { requestJson } from "./apiClient";

export function getAccountDashboard() {
  return requestJson("/api/account/dashboard");
}
